import React from 'react'

//third party
import { useSelector } from 'react-redux'
import ReactLoading from 'react-loading';



const Loading = () => {
    const loading = useSelector((state) => state.loading.value)


    return (
        <>
            {loading ? (
                <div className='loading'>
                    <div className='content'>
                        <ReactLoading type={'spin'} color={'#4387e6'} height={30} width={30} />
                    </div>
                </div>
            ) : null}

        </>
    )
}


export default Loading